export default __webpack_public_path__ + "static/media/app_example_7.ff6eac52.png";